export default __webpack_public_path__ + "static/media/reviewImage2.b7ff5ae3.png";